import { ValidationError } from '@sequencehq/utils'
import deepmerge from 'deepmerge'
import { useMemo } from 'react'

export interface GoCardlessInspectorItemData {
  acceptPaymentsViaGoCardless: {
    value: boolean
    disabled?: boolean
  }
}

export interface GoCardlessInspectorFields {
  acceptPaymentsViaGoCardless: {
    value: boolean
    onChange: (value: boolean) => void
    isDisabled: boolean
    validationErrors: Array<ValidationError>
  }
}

type UseGoCardlessPaymentWidget = (props: {
  dataFromInterface: GoCardlessInspectorItemData
  onChange: (data: GoCardlessInspectorItemData) => void
  disabled?: boolean
}) => {
  fields: GoCardlessInspectorFields
}

export const useGoCardlessPaymentWidget: UseGoCardlessPaymentWidget = ({
  dataFromInterface,
  onChange,
  disabled
}) => {
  const fields = useMemo(() => {
    return {
      acceptPaymentsViaGoCardless: {
        value: dataFromInterface.acceptPaymentsViaGoCardless.value,
        isDisabled:
          (disabled ||
            dataFromInterface.acceptPaymentsViaGoCardless.disabled) ??
          false,
        onChange: (value: boolean) => {
          onChange(
            deepmerge(dataFromInterface, {
              acceptPaymentsViaGoCardless: { value }
            })
          )
        },
        validationErrors: []
      }
    }
  }, [dataFromInterface, onChange, disabled])

  return {
    fields
  }
}
